import type { Error } from '../types';
import { NUMBERS_ONLY_DECIMALS_ALLOWED, NUMBERS_ONLY_REGEXP } from '../utils/regex';

export const numbersOnly =
  (message?: Error['message'], allowEmpty = false, allowDecimals = false) =>
  (value: string): Error => {
    const valid =
      !!value && allowDecimals
        ? NUMBERS_ONLY_DECIMALS_ALLOWED.test(value)
        : NUMBERS_ONLY_REGEXP.test(value);
    return {
      valid: allowEmpty ? !value || valid : valid,
      message
    };
  };
